import { svg } from '@rxdi/lit-html';

export const BookIcon = svg`
<svg
 id="Capa_1"
 enable-background="new 0 0 512 512"
 viewBox="0 0 512 512"
 xmlns="http://www.w3.org/2000/svg"
>
 <g>
  <path
   d="m436 432h-300c-8.284 0-15-6.716-15-15v-402c0-8.284 6.716-15 15-15h300c8.284 0 15 6.716 15 15v402c0 8.284-6.716 15-15 15z"
   fill="#ffe278"
  />
  <path
   d="m436 432c8.284 0 15-6.716 15-15v-402c0-8.284-6.716-15-15-15h-180v432z"
   fill="#ffd845"
  />
  <path
   d="m451 497h-335c-22.091 0-40-17.909-40-40 0-22.091 17.909-40 40-40h335c-22.091 22.091-22.091 57.909 0 80z"
   fill="#fffbf4"
  />
  <path
   d="m116 0c-30.327 0-55 24.673-55 55v402c0 8.284 6.716 15 15 15s15-6.716 15-15c0-13.785 11.215-25 25-25h20v-432z"
   fill="#6ba7ff"
  />
  <path
   d="m376 212h-180c-8.284 0-15-6.716-15-15v-120c0-8.284 6.716-15 15-15h180c8.284 0 15 6.716 15 15v120c0 8.284-6.716 15-15 15z"
   fill="#fffbf4"
  />
  <path
   d="m256 497h195c-22.091-22.091-22.091-57.909 0-80h-195z"
   fill="#f9f4c8"
  />
  <path
   d="m376 62h-120v150h120c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15z"
   fill="#f9f4c8"
  />
  <path
   d="m316 152h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#556e82"
  />
  <path
   d="m316 152c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60v30z"
   fill="#3c4655"
  />
  <path
   d="m376 312h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#556e82"
  />
  <path
   d="m376 372h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#556e82"
  />
  <path
   d="m376 282h-120v30h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
   fill="#3c4655"
  />
  <path
   d="m376 342h-120v30h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
   fill="#3c4655"
  />
  <path
   d="m436 512h-320c-30.327 0-55-24.673-55-55s24.673-55 55-55h320c8.284 0 15 6.716 15 15s-6.716 15-15 15h-320c-13.785 0-25 11.215-25 25s11.215 25 25 25h320c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#93c6ec"
  />
  <g fill="#6ba7ff">
   <path d="m256 402v30h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
   <path
    d="m451 497c0-8.284-6.716-15-15-15h-180v30h180c8.284 0 15-6.716 15-15z"
   />
  </g>
 </g>
</svg>
`;
